import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UserModule } from './modules/user/user.module';
import { LanguageModule } from './modules/language/language.module';
import { CountriesModule } from './modules/countries/countries.module';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { MasterDataModule } from './modules/master-data/master-data.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LanguageModule,
    CountriesModule,
    UserModule,
    AuthenticationModule,
    MasterDataModule
  ],
  exports: [LanguageModule]
})
export class CoreModule {}
